import styled, { css } from "styled-components";

export const Container = styled.div`
  overflow: hidden;
  display: flex;
  height: 100%;
  justify-content: space-between;
  grid-template-columns: auto auto;
  height: 100vh;
  width: 100%;
  .paper {
    width: 346px;
    height: 100%;
  }
  ${({ theme }) => css`
    @media screen and (max-width: ${theme.brand.media_query.tablet}) {
      .paper {
        width: 346px;
      }

      .bg-logo {
        display: none;
      }

      .mt-md {
        margin: 0 auto;
        width: 100%;
      }
    }
    @media screen and (max-width: ${theme.brand.media_query.mobile}) {
      display: flow;
      background-color: ${theme.neutrals.pureWhite};
      .paper {
        width: 100%;
        height: 100%;
        box-shadow: unset;
      }
    }
  `}

  .mt-md {
    display: flex;
    align-items: center;
  }

  .grid-item {
    width: 50%;
    height: 100%;

    .back-btn {
      border: none;
      background: none;
      color: transparent;
      position: fixed;
      left: 50px;
      top: 50px;
      svg {
        cursor: pointer;
      }
    }
    .img-inside {
      width: 100%;
      min-height: 100%;
      object-position: 100% 0%;
      object-fit: cover;
    }
  }

  .white-icon {
    svg path {
      stroke: white;
    }
  }
`;

export const AccessCard = styled.div`
  margin: 0 auto;
  max-width: 450px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme }) => css`
    background-color: ${theme.neutrals.pureWhite};
    padding: ${theme.spacing.xxs}px;
    @media screen and (max-width: ${theme.brand.media_query.mobile}) {
      padding: 0;
    }
  `}
`;
